import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Dropdown from 'Components/Dropdown'
import { _AppDropdown, _Item } from './styles'

const findSelectedOption = (options, selectedVal) => {
  let selectedOption = {}
  options.forEach((option, index) => {
    if(String(option.value) === selectedVal) {
      selectedOption = {
        options,
        index,
      }
    }
  })
  return selectedOption
}


const AppDropdown = ({
  options, onChange, label, selectedVal, mobileFullPagePopup = false,
  gaFromComponent, gaFromPage, isMobileApp,
}) => {
  const [title, updateTitle] = useState(label)
  const [selectedIndex, updateSelectedIndex] = useState(0)
  const onSelectedValUpdate = () => {
    if(!options) return null
    if(selectedVal === -1) {
      updateTitle(options[0].label)
    } else {
      const result = findSelectedOption(options, selectedVal)
      if(result.options) updateTitle(result.options[result.index].label)
      updateSelectedIndex(result.index || 0)
    }
  }
  // initialization
  useEffect(() => {
    onSelectedValUpdate()
  }, [])

  // on clear
  useEffect(() => {
    onSelectedValUpdate()
  }, [selectedVal])

  const _onChange = (option) => {
    onChange({ value: option.value })
    updateTitle(option.label)
  }
  return (
    <_AppDropdown
      fullPage={mobileFullPagePopup}
      isMobileApp={isMobileApp}
    >
      <Dropdown
        title={title}
        blurBackground={false}
        scrollableParentClass={['.searchPageMobileContainerRoot', '.contentView']}
        childClassName={`.${_Item.styledComponentId}`}
        gaFromComponent={gaFromComponent}
        gaFromPage={gaFromPage}
        onKeyboardSelect={(activeIndex) => {
          // cause it hide selected on index messed up
          if(options && options[activeIndex]) {
            let realIndex = activeIndex
            if(selectedIndex <= activeIndex) {
              realIndex += 1
            }
            _onChange(options[realIndex])
          }
        }}
      >
        {
          options && options.map((option, index) => {
            // eslint-disable-next-line
            if(!mobileFullPagePopup && option.value === selectedVal) return null
            return (
              <_Item
                tabIndex="-1"
                selected={option.value === selectedVal}
                key={(option.id || label) + option.value}
                onClick={() => _onChange(option, index)}
                active={option.value === selectedVal}
              >
                {option.label}
              </_Item>
            )
          })
        }
      </Dropdown>
    </_AppDropdown>
  )
}
AppDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  onChange: PropTypes.func,
  label: PropTypes.string,
  selectedVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Handling the edge case which happening only in mobile and for the period dropdown
   */
  mobileFullPagePopup: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  gaFromComponent: PropTypes.string,
  gaFromPage: PropTypes.string,
}
export default AppDropdown
